export default "__VITE_ASSET__D77vvGTG__"